import { render, staticRenderFns } from "./UserFilters.vue?vue&type=template&id=0a6951d5&scoped=true&"
import script from "./UserFilters.vue?vue&type=script&lang=js&"
export * from "./UserFilters.vue?vue&type=script&lang=js&"
import style0 from "./UserFilters.vue?vue&type=style&index=0&id=0a6951d5&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6951d5",
  null
  
)

export default component.exports